import { Button, Flex, Image, Tag } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React, { useState } from 'react';
import { bgSiteImagesAPI, bgV2DataAPI } from '../api/bd-controller';
import { openNotification } from '../meta/globalToaster';

import './bg-page.css';

const BrandDiscoverySiteImages = () => {
  const [loading, setLoading] = useState(false);

  const [response, setResponse] = useState<any>([]);
  const [companyUrl, setCompanyUrl] = useState('');

  const checkBDResult = () => {
    if (companyUrl != '') {
      setResponse([]);
      setLoading(true);

      bgSiteImagesAPI({ companyUrl: companyUrl }).then((data) => {
        try {
          if (data?.status) {
            if (data?.status === 200 && data?.response) {
              successSubmission(data?.response);
            } else {
              failSubmission('Please try again later!');
            }
          } else {
            failSubmission('Please try again later!');
          }
        } catch (error) {
          failSubmission('Please try again later!');
        }
      });
    } else {
      failSubmission('All input fields Required.');
    }
  };

  const successSubmission = (data: any) => {
    setLoading(false);

    setResponse(data);
  };

  const failSubmission = (message: any) => {
    setLoading(false);
    openNotification({ message });
  };

  return (
    <div>
      <div className="container p-3">
        <div className="row">
          <div className="col-sm-12">
            <h4>Brand Discovery</h4>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-9">
            {/* <p className="a-input-label">Company URL</p> */}
            <TextArea
              value={companyUrl}
              onChange={(e) => {
                setCompanyUrl(e?.target?.value);
              }}
              placeholder="Company URL"
              rows={1}
            />
          </div>
          <div className="col-sm-3">
            <Button
              type="primary"
              size="large"
              style={{ width: '100%' }}
              onClick={() => {
                checkBDResult();
              }}
              loading={loading}
            >
              Check Result
            </Button>
          </div>
        </div>

        {response && (
          <>
            <div className="row">
              <div className="col-sm-12">
                <hr />
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <hr />
              </div>
            </div>

            <div className="row">
              <div className="row mt-4">
                <div className="col-sm-12">
                  <p>
                    <b>Images</b>
                  </p>
                </div>
                {response?.map((item: any, index: any) => {
                  return (
                    <div className="col-sm-3 p-5" key={index}>
                      <Image height={100} width={'100%'} src={item} />
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BrandDiscoverySiteImages;
